(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  const logo = 'https://cdn.shopify.com/s/files/1/1070/4030/9593/files/vault-and-vinyl-top-monogram-logo.jpg?v=1793733980';
  const loader = document.createElement('div');
  loader.className = 'vv-page-loader';
  loader.setAttribute('aria-hidden','true');
  loader.innerHTML = '<img alt="" src="'+logo+'">';
  document.addEventListener('DOMContentLoaded', () => {
    document.body.appendChild(loader);
    // Gentle reveal for cards and major homepage sections as they enter view.
    document.documentElement.classList.add('vv-reveal-ready');
    const revealTargets = document.querySelectorAll('.product-card,.collection-card,.vv-brand-group,.vv-home .vv-section-title,.vv-home .vv-eyebrow,.shopify-section:has(.product-grid),.shopify-section:has(.resource-list)');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => entries.forEach(entry => {
        if(entry.isIntersecting){entry.target.classList.add('vv-in-view');observer.unobserve(entry.target);}
      }),{threshold:0.12,rootMargin:'0px 0px -35px 0px'});
      revealTargets.forEach((el,i)=>{el.classList.add('vv-reveal');if(el.matches('.vv-brand-group'))el.classList.add('vv-reveal-stagger');observer.observe(el);});
    } else revealTargets.forEach(el=>el.classList.add('vv-in-view'));
    // Fast branded transition on ordinary same-tab page navigation.
    document.addEventListener('click',(event)=>{
      const link=event.target.closest('a[href]');
      if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.target==='_blank'||link.hasAttribute('download'))return;
      const url=new URL(link.href,location.href);
      if(url.origin!==location.origin||url.pathname===location.pathname||url.hash&&url.pathname===location.pathname)return;
      if(link.closest('cart-drawer-component,dialog,[role="dialog"]'))return;
      loader.classList.add('is-active');
      window.setTimeout(()=>{location.href=url.href;},130);
    },true);
    window.addEventListener('pageshow',()=>loader.classList.remove('is-active'));
  });
  // Branded confirmation after a successful add-to-cart event.
  let toastTimer;
  document.addEventListener('cart:lines-update',(event)=>{
    if(event.detail?.action && event.detail.action!=='add')return;
    const flyProduct=()=>{
      const card=event.target instanceof Element?event.target.closest('product-card'):null;
      const image=card?.querySelector('img');
      const cart=document.querySelector('cart-icon')||document.querySelector('[data-testid="cart-icon"]');
      if(!image||!cart)return;
      const from=image.getBoundingClientRect(),to=cart.getBoundingClientRect();
      if(!from.width||!to.width)return;
      const clone=image.cloneNode(true);
      clone.className='vv-flying-product';
      Object.assign(clone.style,{position:'fixed',zIndex:'100001',left:from.left+'px',top:from.top+'px',width:from.width+'px',height:from.height+'px',objectFit:'cover',margin:'0',pointerEvents:'none',borderRadius:'10px',boxShadow:'0 0 12px #ff1744,0 0 22px #087cff'});
      document.body.appendChild(clone);
      const dx=to.left+to.width/2-(from.left+from.width/2),dy=to.top+to.height/2-(from.top+from.height/2);
      const animation=clone.animate([{transform:'translate(0,0) scale(1)',opacity:1},{transform:'translate('+dx+'px,'+dy+'px) scale(.12)',opacity:.25}],{duration:650,easing:'cubic-bezier(.2,.75,.25,1)'});
      animation.onfinish=()=>clone.remove();
    };
    const show=()=>{flyProduct();
      let toast=document.querySelector('.vv-cart-toast');
      if(!toast){toast=document.createElement('div');toast.className='vv-cart-toast';toast.textContent='GRAIL SECURED — ADDED TO BAG';document.body.appendChild(toast);}
      requestAnimationFrame(()=>toast.classList.add('is-visible'));
      clearTimeout(toastTimer);toastTimer=setTimeout(()=>toast.classList.remove('is-visible'),2300);
    };
    if(event.promise&&typeof event.promise.then==='function')event.promise.then(({detail})=>{if(!detail?.didError)show();}).catch(()=>{});
    else show();
  });
})();